<template>
  <div class="text-center shadow-card p-3 width-300">
    <p class="mb-0 text-muted">{{ title }}</p>
    <p class="mb-0 text-muted" v-if="subTitle">{{ subTitle }}</p>
    <svg-icon name="empty-file" class="fill-icon mt-2" size="28"></svg-icon>
  </div>
</template>

<script>
export default {
  name: 'NoDataMessage',
  props: {
    title: String,
    subTitle: String,
  },
};
</script>
